module.exports = __webpack_public_path__ + "img/markerIconWhiteManyIB.69fa839c.svg";